import React from 'react';
import { createContext } from '@shared/utils/createContext';
import { usePrintDesignsGalleryEventInfoByEventHandleQuery } from './DesignsGallery.graphql.generated';

/**
 * The theme of the event's live website. Tiles of this theme show the "Matches Your Site" badge,
 * and the gallery promotes it to the front.
 *
 * `strict: false` because the public shop and the PDP have no provider: there it is `undefined`.
 */
const [Provider, useWebsiteThemeIdContext] = createContext<string | undefined>({
  name: 'WebsiteThemeIdContext',
  strict: false,
});

/** Queries the website's theme once, so tiles read it here instead of each running the query. */
export const WebsiteThemeIdProvider = ({ eventHandle, children }: Readonly<{ eventHandle?: string; children: React.ReactNode }>) => {
  const { data } = usePrintDesignsGalleryEventInfoByEventHandleQuery({
    batchMode: 'fast',
    variables: {
      eventHandle: eventHandle || '',
    },
    fetchPolicy: 'cache-first',
    skip: !eventHandle,
  });
  return <Provider value={data?.eventByName?.eventDesign?.theme.themeId}>{children}</Provider>;
};

export const useWebsiteThemeId = (): string | undefined => useWebsiteThemeIdContext();
